import {
  SystemActionsList,
  EditActionDefinition,
  SystemActionNames,
} from '@wix/editor-platform-host-integration-apis';
import { t } from '../../../../essentials/i18n';
import { Premium } from '@wix/wix-ui-icons-common';
import React from 'react';
import { ActionFactoryWithPlatformContext } from '../types';

export const upgradeActionFactory: ActionFactoryWithPlatformContext = (
  context,
) => {
  const {
    editorPointer,
    documentServicesAPI,
    editorPointerAPI,
    editorPlatformPackagesBridge,
  } = context;

  const getComponentData = () => {
    const compRef = editorPointerAPI.getDocumentPointer(editorPointer);
    const compData = documentServicesAPI.components.data.get(compRef);
    return compData;
  };

  const getAppData = (appDefinitionId: string) => {
    return documentServicesAPI.tpa.app.getDataByAppDefId(appDefinitionId);
  };

  return {
    actionName: SystemActionsList.upgrade,
    displayName: '',
    tags: [],
    execute: async () => {
      const compData = getComponentData();

      if (!compData?.appDefinitionId) {
        throw new Error(
          'No app definition ID found for the selected component',
        );
      }

      editorPlatformPackagesBridge?.UpgradeUiServiceAPI?.startUpgradeFlow(
        compData.appDefinitionId,
        {
          origin: 'upgrade_action',
        },
      );
    },
    shouldBeExcluded: () => {
      try {
        const compData = getComponentData();

        if (!compData?.appDefinitionId) {
          return true;
        }

        const appData = getAppData(compData.appDefinitionId);

        if (!appData) {
          return true;
        }
        // @ts-expect-error TODO: remove this once type in DM is updated to include openPremiumPage
        const upgradeType = appData.openPremiumPage
          ? 'SITE_UPGRADE'
          : 'APP_UPGRADE';
        const shouldExclude =
          editorPlatformPackagesBridge?.PremiumDataServiceAPI?.isFullyUpgraded(
            compData.appDefinitionId,
            upgradeType,
          );

        return shouldExclude;
      } catch (error) {
        // If there's any error, exclude the upgrade action
        return true;
      }
    },
    uiCustomization: {
      icon: <Premium />,
      displayMode: 'icon',
      tooltip: t('action_bar.premium.hint'),
    },
  } as EditActionDefinition<SystemActionNames>;
};
